import { render, staticRenderFns } from "./ImageShow.vue?vue&type=template&id=cbafb468&scoped=true&"
import script from "./ImageShow.vue?vue&type=script&lang=js&"
export * from "./ImageShow.vue?vue&type=script&lang=js&"
import style0 from "./ImageShow.vue?vue&type=style&index=0&id=cbafb468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbafb468",
  null
  
)

export default component.exports